import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Pagination} from "../shared/interfaces/pagination";
import {Observable, throwError} from "rxjs";
import {PaginatedResponse} from "../models/paginated-response";
import {environment} from "../../environments/environment";
import {TrailerModel} from "../models/trailer.model";
import {DriverRegistration} from "../models/user.registration";
import {catchError, map} from "rxjs/operators";
import {TrailerCreator} from "../models/trailer.creator";

export interface TrailersFilter {
  organizationId?: number;
  description?: string;
  showDeleted?: boolean;
}

@Injectable()
export class TrailerDataSource {
  constructor(
    private http: HttpClient,
  ) {
  }

  getTrailers(pagination: Pagination = {}, filters: TrailersFilter = {}): Observable<PaginatedResponse<TrailerModel>> {
    const params = {};
    if (pagination?.pageNumber) {
      params['pageNumber'] = pagination.pageNumber;
    }

    if (pagination?.pageSize) {
      params['pageSize'] = pagination.pageSize;
    }

    if (pagination?.removeLimit) {
      params['removeLimit'] = pagination.removeLimit;
    }

    if (filters?.organizationId) {
      params['organizationId'] = filters.organizationId;
    }

    if (filters?.showDeleted) {
      params['showDeleted'] = true;
    }

    if (filters?.description && filters.description !== '') {
      params['description'] = filters.description;
    }
    return this.http.get<PaginatedResponse<TrailerModel>>(environment.backendApi + 'api/Trailers', {params});
  }


  createTrailer(model: TrailerCreator, imageFile: File): Observable<any> {
    const formData = new FormData();
    formData.append('modelData', JSON.stringify(model));
    if (imageFile && imageFile.size > 0 ) {
      formData.append('imageFile', imageFile);
    }

    console.log("create trailer data", formData, "imageFile", imageFile);

    // Sends an authenticated request.
    return this.http.post<Response>(environment.backendApi + 'api/Trailers', formData).pipe(
      map((response: Response) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(error);
      }));
  }

  editTrailer(model: TrailerCreator, imageFile: File, trailerId: number): Observable<any> {
    const formData = new FormData();
    formData.append('modelData', JSON.stringify(model));
    if (imageFile && imageFile.size > 0 ) {
      formData.append('imageFile', imageFile);
    }

    console.log("create trailer data", formData, "imageFile", imageFile);

    // Sends an authenticated request.
    return this.http.put<Response>(environment.backendApi + 'api/Trailers/' + trailerId, formData).pipe(
      map((response: Response) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(error);
      }));
  }

  delete(trailerId: number): Observable<void> {
    return this.http.delete<void>(environment.backendApi + `api/Trailers/${trailerId}`);
  }

}
